/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactDetailResponseDtoSchema } from "../contactDetailResponseDtoSchema";
import { z } from "zod/v4";

export const getContactPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const getContactHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

export const getContact200Schema = z.lazy(() => contactDetailResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const getContact401Schema = z.any()

export const getContactQueryResponseSchema = z.lazy(() => getContact200Schema)